import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const s = {
  page: { minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2rem', gap: '2rem' },
  header: { display: 'flex', alignItems: 'center', gap: '1rem', width: '100%', maxWidth: '700px' },
  back: { background: 'rgba(255,255,255,0.1)', color: 'white', borderRadius: '12px', padding: '0.5rem 1rem', fontSize: '1.2rem', border: 'none', cursor: 'pointer' },
  xpBar: { background: 'rgba(255,255,255,0.05)', borderRadius: '16px', padding: '1.5rem', width: '100%', maxWidth: '700px', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', textAlign: 'center' },
  xpLabel: { fontSize: '0.75rem', color: 'var(--text-muted)', fontWeight: '700', textTransform: 'uppercase' },
  subjects: { display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', maxWidth: '700px' },
  subjectEmoji: { fontSize: '3rem' },
  subjectXP: { fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '700' },
};

const SUBJECTS = [
  { key: 'matematik', label: 'Matematik', emoji: '🔢', desc: 'Multiplikation og tricks', color: '#f9c74f' },
  { key: 'dansk', label: 'Dansk', emoji: '📝', desc: 'Diktat og stavning', color: '#f3722c' },
  { key: 'geografi', label: 'Geografi', emoji: '🌍', desc: 'Flag, kort og hovedstæder', color: '#43aa8b' },
];

export default function UserPage({ user, name, age, color, emoji }) {
  const navigate = useNavigate();
  const [xp, setXp] = useState(null);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    fetch('/api/xp/'+user).then(r => r.json()).then(setXp).catch(() => {});
  }, [user]);

  const totalYear = xp ? Object.values(xp).reduce((s, v) => s + (v.year || 0), 0) : 0;
  const totalWeek = xp ? Object.values(xp).reduce((s, v) => s + (v.week || 0), 0) : 0;
  const totalToday = xp ? Object.values(xp).reduce((s, v) => s + (v.today || 0), 0) : 0;

  return (
    <div style={s.page}>
      <div style={s.header}>
        <button style={s.back} onClick={() => navigate('/')}>tilbage</button>
        <h1 style={{ fontFamily: 'Bangers, cursive', fontSize: '2rem', letterSpacing: '3px', color, flex: 1 }}>{emoji} {name}</h1>
      </div>
      <div style={s.xpBar}>
        {[['I dag', totalToday], ['Denne uge', totalWeek], ['I år', totalYear]].map(([label, val]) => (
          <div key={label}>
            <div style={{ fontSize: '2rem', fontWeight: '900', fontFamily: 'Bangers, cursive', letterSpacing: '2px', color }}>{xp ? val : '...'}</div>
            <div style={s.xpLabel}>{label}</div>
          </div>
        ))}
      </div>
      <div style={s.subjects}>
        {SUBJECTS.map(sub => (
          <button
            key={sub.key}
            style={{ background: hovered === sub.key ? sub.color+'15' : 'rgba(255,255,255,0.05)', borderRadius: '20px', padding: '1.5rem 2rem', display: 'flex', alignItems: 'center', gap: '1.5rem', cursor: 'pointer', border: '2px solid '+(hovered === sub.key ? sub.color : 'transparent'), transition: 'all 0.2s ease', width: '100%', color: 'white' }}
            onMouseEnter={() => setHovered(sub.key)}
            onMouseLeave={() => setHovered(null)}
            onClick={() => navigate('/'+user+'/'+sub.key)}
          >
            <span style={s.subjectEmoji}>{sub.emoji}</span>
            <div style={{ flex: 1, textAlign: 'left' }}>
              <div style={{ fontSize: '1.8rem', fontFamily: 'Bangers, cursive', letterSpacing: '2px', color: sub.color }}>{sub.label}</div>
              <div style={s.subjectXP}>{sub.desc} - {xp ? (xp[sub.key] ? xp[sub.key].year : 0) : '...'} XP i år</div>
            </div>
            <span style={{ fontSize: '1.5rem', opacity: 0.5 }}>›</span>
          </button>
        ))}
      </div>
    </div>
  );
}
